"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledRefineModalBody = exports.StyledRefineModalRoot = exports.StyledButtonRefine = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledButtonRefine = styled_components_1.default.div `
  padding-left : ${({ theme: { spacing } }) => spacing(1.5)};
  > button {
    background: ${ui_components_1.baseColors.white};
  }
  svg {
    height: 0.9rem !important;
    width: 0.9rem !important;
    padding-right: ${({ theme: { spacing } }) => spacing(0.8)};
  }
`;
exports.StyledRefineModalRoot = (0, styled_components_1.default)(material_1.Box) `
  && {
    background: ${ui_components_1.baseColors.background100};
  }
`;
exports.StyledRefineModalBody = (0, styled_components_1.default)(material_1.Box) `
  && {
    padding: ${({ theme: { spacing } }) => spacing(2.5)};
    .RefineModal-Accordion-Wrap {
      border-radius: 0.5rem;
      background: ${ui_components_1.baseColors.white};
      > div {
        padding: ${({ theme: { spacing } }) => spacing(1.6)};
      }
    }
  }
`;
